import { Component } from '@angular/core';

@Component({
  selector: 'prism-home',
  standalone: false,
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {
}
